// ---------------------------------------------------------------------------
// FAQ topics - drives landing page cards and topic overview pages
// ---------------------------------------------------------------------------
// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility
import { FAQ_ARTICLE_IDS } from './faq-articles.const.js'

export const FAQ_TOPICS = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    icon: 'sparkles',
    color: 'brand-dark',
    description:
      'Learn what the platform is, understand key concepts, and navigate your home dashboard.',
    sections: [
      {
        title: 'Overview',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_THIS_PLATFORM, icon: 'globe' },
          { articleId: FAQ_ARTICLE_IDS.KEY_CONCEPTS, icon: 'list' },
        ],
      },
      {
        title: 'Essentials',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_A_REQUEST, icon: 'file-text' },
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_AN_APPROVAL, icon: 'shield-check' },
          { articleId: FAQ_ARTICLE_IDS.WHAT_ARE_CONFIRMATIONS, icon: 'list-checks' },
        ],
      },
      {
        title: 'Your dashboard',
        items: [{ articleId: FAQ_ARTICLE_IDS.YOUR_HOME_DASHBOARD, icon: 'layout-dashboard' }],
      },
    ],
  },
  {
    id: 'submitting-a-request',
    title: 'Submitting a Request',
    icon: 'clipboard-plus',
    color: 'cta',
    description:
      'Everything you need to know about creating and submitting a request for AI tool access.',
    sections: [
      {
        title: 'Understanding requests',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_A_REQUEST, icon: 'info' },
          { articleId: FAQ_ARTICLE_IDS.HOW_TO_SUBMIT, icon: 'clipboard-list' },
        ],
      },
      {
        title: 'Drafts & evidence',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_A_DRAFT, icon: 'file-edit' },
          { articleId: FAQ_ARTICLE_IDS.UPLOADING_FILES, icon: 'paperclip' },
        ],
      },
    ],
  },
  {
    id: 'after-you-submit',
    title: 'After You Submit',
    icon: 'clock',
    color: 'info',
    description:
      'Track your request, understand outcomes, and learn what to do if your request is denied.',
    sections: [
      {
        title: 'Following your request',
        items: [{ articleId: FAQ_ARTICLE_IDS.TRACKING_YOUR_REQUEST, icon: 'clock' }],
      },
      {
        title: 'When a decision is made',
        items: [
          { articleId: FAQ_ARTICLE_IDS.REQUEST_APPROVED, icon: 'check-circle' },
          { articleId: FAQ_ARTICLE_IDS.REQUEST_DENIED, icon: 'badge-x' },
        ],
      },
      {
        title: 'If you need to reapply',
        items: [{ articleId: FAQ_ARTICLE_IDS.DUPLICATING_A_REQUEST, icon: 'copy' }],
      },
    ],
  },
  {
    id: 'approvals',
    title: 'Approvals',
    icon: 'shield-check',
    color: 'positive',
    description:
      'Understand your active approvals, what revocation means, and how to manage access.',
    sections: [
      {
        title: 'Understanding approvals',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_IS_AN_APPROVAL, icon: 'shield-check' },
          { articleId: FAQ_ARTICLE_IDS.ACTIVE_VS_REVOKED, icon: 'circle-dot' },
        ],
      },
      {
        title: 'Managing access',
        items: [{ articleId: FAQ_ARTICLE_IDS.HOW_TO_REVOKE, icon: 'ban' }],
      },
    ],
  },
  {
    id: 'confirmations',
    title: 'Confirmations',
    icon: 'list-checks',
    color: 'cyan',
    description: 'Learn about usage confirmations. Each approval has its own due date.',
    sections: [
      {
        title: 'Understanding confirmations',
        items: [
          { articleId: FAQ_ARTICLE_IDS.WHAT_ARE_CONFIRMATIONS, icon: 'list-checks' },
          { articleId: FAQ_ARTICLE_IDS.HOW_TO_CONFIRM, icon: 'check-circle' },
        ],
      },
    ],
  },
  {
    id: 'general',
    title: 'General',
    icon: 'help-circle',
    color: 'violet',
    description: 'Get help with support, missing products, and other common questions.',
    sections: [
      {
        title: 'Support & catalog',
        items: [
          { articleId: FAQ_ARTICLE_IDS.CONTACTING_SUPPORT, icon: 'message-circle' },
          { articleId: FAQ_ARTICLE_IDS.PRODUCT_NOT_IN_CATALOG, icon: 'package-search' },
        ],
      },
      {
        title: 'Settings',
        items: [
          { articleId: FAQ_ARTICLE_IDS.SET_UP_NOTIFICATIONS, icon: 'bell' },
          { articleId: FAQ_ARTICLE_IDS.INTEGRATIONS, icon: 'workflow' },
          { articleId: FAQ_ARTICLE_IDS.ADDITIONAL_EMAIL_ADDRESSES, icon: 'mail' },
        ],
      },
      {
        title: 'Troubleshooting',
        items: [{ articleId: FAQ_ARTICLE_IDS.NOTIFICATIONS_NOT_ARRIVING, icon: 'bell-off' }],
      },
      {
        title: 'Submitting',
        items: [{ articleId: FAQ_ARTICLE_IDS.HOW_TO_SUBMIT, icon: 'clipboard-list' }],
      },
    ],
  },
]
